import { styleConstants } from "~/style/styleConstants";
import type { SupportedLanguage } from "./SupportedLanguage";

export function LanguagePicker() {
  return (
    <select
      defaultValue={intl.locale}
      onChange={async (event) => {
        const locale = event.target.value;
        await intl.changeLanguage(locale as SupportedLanguage);
      }}
      className="bg-backgroundTheme-100 border border-textTheme-200 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 p-1.5"
      style={{
        backgroundColor: styleConstants.colorTextLightSofter,
        border: "none",
        fontSize: styleConstants.fontSizeExtraLarge,
        paddingLeft: 4,
        paddingRight: 4,
        appearance: "none",
        borderRadius: 2,
      }}
    >
      {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
      <option value="hr">🇭🇷</option>
      {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
      <option value="en">🇺🇸</option>
    </select>
  );
}
